<!--Componente que ayuda a realizar la migración de los afiliados
    Se carga  un csv con las siguientes columnas
    date, name, lastName, affiliateId, email, tel
    
    date: Es la fecha en la que el asistente realizó su pago de la afiliación, ya sea dentro o fuera del sistema
          La fecha debe de tener el siguiente formato 10-15-2020
    name: Solo es el nombre(s) del afiliado
    lastName: Apellido(s) del afiliado
    affiliateId: Id que se le asignará al afiliado
          El Id de afiliado debe ser tipo entero Ej. 74
    email: Email del afiliado, primero se tiene que comprobar que el afiliado no esta regristrado como usuario en la plataforma
    tel: Telefono del afiliado. Ej. 4771231231
-->
<!--
    Pasos para realizar una migración de afiliados correctamente
    1.- Crear un archivo csv con los registros de los afiliados y respetando las columnas que se muestra anteriormente
        (LAS LISTAS DEBEN DE TENER COMO MÁXIMO 5 registros de afiliados)
    2.- Comprobar que en la base de datos en la tabla de "User" que no se encuentran registrados como usuarios los correos de los afiliados
    3.- En el campo de "Id de afiliación" ingresar el id al que van a pertenecer los afiliados
    4.- En el campo de "Nombre de nivel" ingresar el nivel de afiliación al que pertenecen los afiliados
    5.- En periocidad de cobro ingresar Anual
-->
<!--Es importante que el afiliado que se va a migrar no cuente con un usuario para que se pueda hacer la migración de ese
    afiliado a ese plan de forma satisfactoria
-->

<template>
  <v-container>
    <v-row class="text-center">
      <v-col cols="12" class="text-center text-md-left pb-0">
        <p class="headline font-weight-bold">Migración de afiliados</p>
      </v-col>
      <v-col cols="12" sm="8">
        <v-file-input multiple label="File input" v-model="fileCsvVuetify" @change="loadCSV()"></v-file-input>
      </v-col>
      <v-col cols="12" sm="4">
        <v-btn @click="sendDataAffiliates()" color="amber" :disabled="migrateDataAffiliates.planId =='' || migrateDataAffiliates.tier.name == '' || migrateDataAffiliates.tier.interval == ''">Migrar datos de afiliación</v-btn>
      </v-col>
      <v-col cols="12">
        <p class="headline">Datos de afiliación</p>
      </v-col>
      <v-col cols="12" md="4">
        <v-text-field
          label="Id de afiliación"
          type="text"
          v-model="migrateDataAffiliates.planId"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="4">
        <v-text-field
          label="Nombre de nivel"
          type="text"
          v-model="migrateDataAffiliates.tier.name"
        ></v-text-field>
      </v-col>
      <!--<v-col cols="12" md="4">
        <v-text-field
          label="Precio de nivel"
          type="text"
          v-model="migrateDataAffiliates.tier.interval"
        ></v-text-field>
      </v-col>-->
      <v-col cols="12" md="4">
        <v-select
          v-model="migrateDataAffiliates.tier.interval"
          :items="affiliationIntervals"
          label="Perioricidad de cobro"
        ></v-select>
      </v-col>
      <v-col cols="12">
        <v-data-table
          :headers="tableHeaders"
          :items="parse_csv"
          class="elevation-1"
        >
        </v-data-table>
      </v-col>
      <!--<v-col cols="12">
        <div id="app">
          <div class="container">
            <div class="panel panel-sm">
              <div class="panel-heading"> 
                <h4>CSV Import</h4>
              </div>
              <div class="panel-body">
                <div class="form-group">
                  <label for="csv_file" class="control-label col-sm-3 text-right">CSV file to import</label>
                  <div class="col-sm-9">
                    <input type="file" id="csv_file" name="csv_file" class="form-control" @change="loadCSV($event)">
                  </div>
                </div>
                <div class="col-sm-offset-3 col-sm-9">
                  <div class="checkbox-inline">
                    <label for="header_rows"><input type="checkbox" id="header_rows"> File contains header row?</label>
                  </div>
                </div>
                <div class="col-sm-offset-3 col-sm-9">
                  <a href="#" class="btn btn-primary">Parse CSV</a>
                </div>
                <table v-if="parse_csv">
                  <thead>
                    <tr>
                      <th v-for="key in parse_header"
                          @click="sortBy(key)"
                          :class="{ active: sortKey == key }">
                        {{ key | capitalize }}
                        <span class="arrow" :class="sortOrders[key] > 0 ? 'asc' : 'dsc'">
                        </span>
                      </th>
                    </tr>
                  </thead> 
                  <tr v-for="csv in parse_csv">
                    <td v-for="key in parse_header">
                      {{csv[key]}}
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </v-col>-->
    </v-row>
  </v-container>
</template>

<script>

import { mapState, mapMutations, mapGetters, mapActions} from 'vuex';

export default {
  name: 'HelloWord',
  data() {
    return {
      channel_name: '',
      channel_fields: [],
      channel_entries: [],
      parse_header: [],
      parse_csv: [],
      sortOrders:{},
      sortKey: '',
      fileCsvVuetify: null,
      csvData: "",
      migrateDataAffiliates: {
        planId: "",
        tier: {
          name: "",
          amount: 0,
          interval: ""
        },
        affiliatesData: []
      },
      tableHeaders: [],
      affiliationIntervals: [
        { text: "Mensual", value: "month" },
        { text: "Anual", value: "year" }
      ],
    };
  },
  filters: {
    capitalize: function (str) {
      return str.charAt(0).toUpperCase() + str.slice(1)
    }
  },
  methods: {
    ...mapActions("affiliation", ["migrateAffiliations"]),
    ...mapMutations("notifications", ["show"]),
    /**
     * Función que manda a llamar a la acción para realizar la migración de los afiliados
     */
    async sendDataAffiliates(){
      try {
        await this.migrateAffiliations(this.migrateDataAffiliates);
        this.show({ text: "Migración de afiliados exitosa"});
      } catch (error) {
        console.log(error)
        this.show({ text: "Ha ocurrido un problema 😔", color: "yellow darken-3" });
      }

    },
    sortBy: function (key) {
      var vm = this
      vm.sortKey = key
      vm.sortOrders[key] = vm.sortOrders[key] * -1
    },
    /**
     * Función que convierte los datos del CSV para que puedan ser mostrados en la tabla
     * @param { Array<Object> } csv Arreglo de objetos que contiene la lista de los afiliados
     */
    csvJSON(csv){
      var vm = this
      var lines = csv.split("\n")
      var result = []
      var headers = lines[0].split(",")
      vm.parse_header = lines[0].split(",")
      //console.log(vm.parse_header);
      this.tableHeaders = vm.parse_header.map(header => {
        return { text: header, align: 'center', value: header}
      });
      //console.log(this.tableHeaders);
      lines[0].split(",").forEach(function (key) {
        vm.sortOrders[key] = 1
      })
      lines.map(function(line, indexLine){
        if (indexLine < 1) {
          return
        } // Jump header line
        var obj = {}
        var currentline = line.split(",")
        if (currentline.length == 1 && currentline[0]== ""){
          return;
        }
        headers.map(function(header, indexHeader){
          obj[header] = currentline[indexHeader]
        })
        //delete obj["fin_documento\r"];
        result.push(obj)
      })
      //result.pop() // remove the last item because undefined values
      return result // JavaScript object
    },
    /**
     * Función que obtiene el archivo ingresado en el "v-file-input" al momento de que este detecta un cambio
     */
    async loadCSV() {
      var self = this;
      if (window.FileReader) {
        var reader = new FileReader();
        reader.readAsBinaryString(this.fileCsvVuetify[0]);
        // Handle errors load
        reader.onload = (event) => {
          var csv = event.target.result.replace(/\r/g, "\n");
          self.parse_csv = self.csvJSON(csv)
          self.migrateDataAffiliates.affiliatesData = self.parse_csv;
        };
        
        reader.onerror = (evt) => {
          if(evt.target.error.name == "NotReadableError") {
            alert("Canno't read file !");
          }
        };
        
      } else {
        alert('FileReader are not supported in this browser.');
      }
    },
    imprimirDatos() {
      console.log(this.parse_csv);
    }
  }
//  methods: {
//    async convertirCSV(){
//      //console.log("dsadsasaddas");
//      //CSVToJSON().fromFile("../assets/Asistentes.csv").then((source) => {
//      //  console.log(source);
//      //})
//      let json = csvToJson.getJsonFromCsv("../assets/Asistentes.csv");
//      for(let i=0; i<json.length;i++){
//          console.log(json[i]);
//      }
//    }
//  },
//  async created() {
//    //const jsonArray= await CSVToJSON().fromFile("../assets/Asistentes.csv");
//    //console.log(jsonArray);
//  },
//  components: {
//    FilePond
//  }
}
</script>
<style scoped>
html, body {
  margin: 0;
  padding: 0;
}
body {
  margin: 32px auto;
}
.panel {
  border: 2px solid #DFDFDF;
  box-shadow: rgba(0, 0, 0, 0.15) 0 1px 0 0;
  margin: 10px;
} 
.panel.panel-sm {
  margin: 10px auto;
}
.panel-heading {
  border-bottom: 2px solid #DFDFDF;
}
.panel-heading h1, .panel-heading h2, .panel-heading h3, .panel-heading h4, .panel-heading h5, .panel-heading h6 {
  margin: 0;
  padding: 0;
}
.panel-body .checkbox-inline {
  padding: 15px 20px;
}
table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}
td, th {
  border: 1px solid #DDDDDD;
  text-align: left;
  padding: 8px;
}
tr:nth-child(even) {
  background-color: #DDDDDD;
}
</style>